import { Pipe, PipeTransform } from '@angular/core';
import { DetectionMode, DetectionStatus } from '../../enums/detection';
import { TranslocoService } from '@jsverse/transloco';
import { Detection } from '../../models/detection';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  selectDetectionLabelEntities
} from '../../features/detection-label/detection-label.selectors';
import { map } from 'rxjs/operators';


@Pipe({
    name: 'formatDetectionMode',
    standalone: false
})
export class FormatDetectionModePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
  }

  transform(detectionMode: number | string): string {
    if(detectionMode == DetectionMode.AUTO) {return this.translocoService.translate('automatic_detection');}
    return this.translocoService.translate('manual_detection');
  }
}

@Pipe({
    name: 'formatDetectionStatus',
    standalone: false
})
export class FormatDetectionStatusPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
  }

  transform(detectionStatus: number): string {
    if(detectionStatus == DetectionStatus.TO_BE_CONFIRMED) {return this.translocoService.translate('to_confirm')}
    if(detectionStatus == DetectionStatus.CONFIRMED) {return this.translocoService.translate('confirmed');}
    return 'Inconnu';
  }
}


@Pipe({
    name: 'distinctDetectionLabels',
    standalone: false
})
export class DistinctDetectionLabelsPipe implements PipeTransform {

  transform(items: Array<Detection>): Array<string> {
    if (!items) return [];
    return [...new Set(items.map(d => d.label))];
  }
}

@Pipe({
    name: 'distinctDetectionCreateModes',
    standalone: false
})
export class DistinctDetectionCreateModesPipe implements PipeTransform {

  transform(items: Array<Detection>): Array<string> {
    if (!items) return [];
    return [...new Set(items.map(d => d.createMode.toString()))];
  }
}


@Pipe({
    name: 'confidence',
    standalone: false
})
export class DetectionConfidencePipe implements PipeTransform {

  transform(detection: Detection): number {
    if (detection?.createMode == DetectionMode.USER) {
      return 100;
    }
    else {
      return (detection?.confidence) ? Math.round(detection.confidence * 100) : 0
    }
  }
}

@Pipe({
    name: 'evolution',
    standalone: false
})
export class DetectionEvolutionPipe implements PipeTransform {

  transform(detection: Detection): number {
    return (detection?.evolution) ? Math.round(detection.evolution * 100) : 0
  }
}

@Pipe({
    name: 'status',
    standalone: false
})
export class DetectionStatusPipe implements PipeTransform {

  constructor(private translocoService: TranslocoService) {
  }

  transform(detection: Detection): string {
    // if (detection.status == DetectionStatus.TO_BE_CONFIRMED) {
    //   return this.translocoService.translate('to_confirm')
    // }
    if (detection.status == DetectionStatus.CONFIRMED && !detection.emergency) {
       return this.translocoService.translate('confirmed')
    }
    else if (detection.status == DetectionStatus.CONFIRMED && detection.emergency) {
      return detection.emergency.label
    }
    return ''
  }
}


@Pipe({
  name: 'detectionLabel',
  standalone: false,
})
export class DetectionLabelPipe implements PipeTransform {

  constructor(private readonly store: Store) {}

  transform(key: string): Observable<string> {
    return this.store.select(selectDetectionLabelEntities).pipe(
      map(entities => entities[key]?.label ?? key),
    );
  }
}
